
export type TimeSeriesRangeType = "None" | "Last";